// ── User Management API (super_admin only) ───────────────────
const BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:4000";

function authHeaders() {
  const token = localStorage.getItem("accessToken") || "";
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

// List semua users
export async function fetchUsers() {
  const res = await fetch(`${BASE}/api/auth/users`, { headers: authHeaders() });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Gagal memuat users");
  return data.users;
}

// Tambah admin baru
export async function createUser({ username, password, role }) {
  const res = await fetch(`${BASE}/api/auth/users`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify({ username, password, role }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Gagal membuat user");
  return data;
}

// Update user (username, role, password, status, is_active)
export async function updateUser(id, fields) {
  const res = await fetch(`${BASE}/api/auth/users/${id}`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify(fields),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Gagal update user");
  return data;
}

// Hapus user
export async function deleteUser(id) {
  const res = await fetch(`${BASE}/api/auth/users/${id}`, {
    method: "DELETE",
    headers: authHeaders(),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Gagal hapus user");
  return data;
}

// Ganti password sendiri
export async function changePassword({ oldPassword, newPassword }) {
  const res = await fetch(`${BASE}/api/auth/change-password`, {
    method: "PUT",
    headers: authHeaders(),
    body: JSON.stringify({ oldPassword, newPassword }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Gagal ganti password");
  return data;
}
